import axios from "axios";
import AuthService from "../../Admin/services/AuthService";

const API_URL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config) =>
  AuthService.prepareAuthenticatedRequest(config)
);

function unwrap(data) {
  if (data && Array.isArray(data.$values)) return data.$values;
  return data;
}

const ChannelIntegrationService = {
  getByClientId: async (clientId) => {
    const response = await axios.get(`${API_URL}/ClientChannelConfig/GetByClientId/${clientId}`);
    return unwrap(response.data) ?? [];
  },

  getByClientIdAndChannel: async (clientId, channelType) => {
    const response = await axios.get(
      `${API_URL}/ClientChannelConfig/GetByClientIdAndChannel/${clientId}/${channelType}`
    );
    return response.data;
  },

  upsert: async (payload) => {
    const response = await axios.post(`${API_URL}/ClientChannelConfig/Upsert`, payload);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_URL}/ClientChannelConfig/Delete/${id}`);
    return response.data;
  },
};

export default ChannelIntegrationService;
